import { useQuery } from '@tanstack/react-query';
import { BulkUpdateService } from '@/services/agent/bulk/BulkUpdateService';
import type { BulkUpdateJobFilters } from '@/types/agent/bulk-update';

export const useBulkUpdateJobs = (
  filters?: BulkUpdateJobFilters,
  page: number = 1,
  pageSize: number = 50,
) => {
  return useQuery({
    queryKey: ['bulk-update-jobs', filters, page, pageSize],
    queryFn: () => BulkUpdateService.getJobs(filters, pageSize, (page - 1) * pageSize),
    staleTime: 1000 * 30,
  });
};
